import locales from '../locales/config';

export default () => {
  const defaultLocale = Object.values(locales).find((locale) => locale.default);
  return defaultLocale.path || 'en';
};
